import { RailwaySearchModule } from "./RailwayModule/RailwaySearchModule";
import { ErrorPopup } from "./Components/ErrorPopup";
import { Util } from "../../Common/Util";

class Railway {
    constructor() {
        this.$rootWrapper = $('.railway-search-module');
        this._route = `${Util.getLocalization()}train/search/f/`;

        this._lang = $('html').attr('lang');

        this._init();
    }

    _init() {
        this._railwaySearchModule = new RailwaySearchModule({
            page: this.$rootWrapper,
            route: this._route,
            handler: this._searchTickets,
            error: this._searchTicketsError,
            success: this._searchTicketsSuccess,
        })
    }

    _searchTickets(event) {
        event.preventDefault();

        const stateFrom = this._stationFrom.getSelectedCity();
        const stateTo = this._stationTo.getSelectedCity();
        const startDate = this._datepicker.getStartDate();
        const endDate = this._datepicker.getEndDate();

        const date = endDate ? `${startDate}_${endDate}` : startDate;

        let route = `${this._route}${stateFrom.val.replace(' ', '-')}/${stateTo.val.replace(' ', '-')}/${stateFrom.id}/${stateTo.id}/${date}/`;

        window.location = route;
    }

    _searchTicketsSuccess(data) {
        console.log(data.message);
    }

    _searchTicketsError(data) {
        ErrorPopup.show();
    }
}

$(() => {
    $( '.bus_overlay, .bus_popup_close, [data-close-popup]' ).click( function() {
        $( 'html' ).removeClass( '_open_bus_popup' );
        $( '.bus_overlay' ).removeClass( '_active' );
        $( '.bus_popup' ).removeClass( '_active' );
        $( '.popup_places' ).removeClass( '_active' );
    });


    //Показать окно ошибки сервиса
    // if (window.location.pathname === '/train/' || window.location.pathname === '/ru/train/') {
    //     $('html').addClass('_open_bus_popup');
    //     $('.bus_overlay').addClass('_active');
    //     $('#service_unavailable_popup').addClass('_active');
    // }
    
    new Railway;
});